export { default } from '@kamernet/modules/Error/pages/ErrorNotFound/ErrorNotFound.page';
